
import { Income, Expense, Student, ApiResponse, User } from '../types';

const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycby8n4vpT0hHC9D7mMS7NAOM_f8E1CyLfvJGiXG6jRclbwCZEWYNxjOuNownlyYiQSpv/exec';

export const apiService = {
  async login(username: string, password: string): Promise<ApiResponse<User>> {
    console.log(`[API] Mencoba login: ${username}`);
    
    try {
      const response = await fetch(SCRIPT_URL, {
        method: 'POST',
        // Menggunakan mode 'cors' dan redirect 'follow' sangat penting untuk Google Apps Script
        mode: 'cors',
        redirect: 'follow',
        body: JSON.stringify({ 
          action: 'login', 
          username: username, 
          password: password 
        }),
      });
      
      const text = await response.text();
      let result;
      
      try {
        result = JSON.parse(text);
      } catch (e) {
        // Jika server mengembalikan "Action not found" dalam bentuk teks biasa
        if (text.includes("Action not found")) {
          throw new Error("Action 'login' tidak ditemukan di script backend Anda.");
        }
        throw new Error("Respons server bukan JSON yang valid.");
      }

      console.log("[API] Respons:", result);
      return result;
    } catch (error: any) {
      console.warn("[API] Login gagal:", error.message);
      
      // Fallback: Inanda26 tetap bisa masuk sebagai backup jika server bermasalah
      const validUsers = [
        { u: 'admin', p: 'admin123', name: 'Super Admin' },
        { u: 'inanda26', p: 'inanda26', name: 'Inanda Aulia' }
      ];

      const found = validUsers.find(user => 
        user.u.toLowerCase() === username.toLowerCase() && 
        user.p.toLowerCase() === password.toLowerCase()
      );
      
      if (found) {
        return { 
          success: true, 
          data: { username: found.name, role: 'Admin' } 
        };
      }
      
      return { success: false, message: error.message || 'Gagal terhubung ke server.' };
    }
  },

  async getAllData(): Promise<{ pemasukan: Income[], pengeluaran: Expense[], siswa: Student[] }> {
    try {
      const response = await fetch(`${SCRIPT_URL}?action=getData&t=${new Date().getTime()}`);
      const result = await response.json();
      
      if (result.pemasukan) localStorage.setItem('kas_pemasukan', JSON.stringify(result.pemasukan));
      if (result.pengeluaran) localStorage.setItem('kas_pengeluaran', JSON.stringify(result.pengeluaran));
      if (result.siswa) localStorage.setItem('kas_siswa', JSON.stringify(result.siswa));

      return {
        pemasukan: result.pemasukan || [],
        pengeluaran: result.pengeluaran || [],
        siswa: result.siswa || []
      };
    } catch (error) {
      return {
        pemasukan: JSON.parse(localStorage.getItem('kas_pemasukan') || '[]'),
        pengeluaran: JSON.parse(localStorage.getItem('kas_pengeluaran') || '[]'),
        siswa: JSON.parse(localStorage.getItem('kas_siswa') || '[]')
      };
    }
  },

  async submitTransaction(type: 'Pemasukan' | 'Pengeluaran', payload: any): Promise<ApiResponse<any>> {
    try {
      await fetch(SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors',
        body: JSON.stringify({ action: 'submitData', type, payload }),
      });
      return { success: true };
    } catch (error) {
      return { success: false, message: 'Gagal kirim data.' };
    }
  },

  async submitStudent(payload: Student): Promise<ApiResponse<Student>> {
    try {
      await fetch(SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors',
        body: JSON.stringify({ action: 'submitStudent', payload }),
      });
      return { success: true, data: payload };
    } catch (error) {
      return { success: false };
    }
  },

  async deleteTransaction(type: 'Pemasukan' | 'Pengeluaran', id: string): Promise<ApiResponse<null>> {
    try {
      await fetch(SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors',
        body: JSON.stringify({ action: 'deleteData', type, id }),
      });
      return { success: true };
    } catch (error) {
      return { success: false };
    }
  }
};
